import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import type { SpecimenFeature } from '../../graphql/generated/graphql.ts';

export type Label = {
  id: string;
  name: string;
  number: string;
  features: SpecimenFeature[];
  text: string;
  text2: string;
  location: string;
  color: string;
  specialPrinterRequired: boolean;
};

export type ScannedOrder = {
  id: string;
  number: string;
  availableLabels: number;
  request: {
    id: string;
    patientData: {
      title: string;
      firstName: string;
      lastName: string;
    };
    doctor: {
      id: string;
      name: string;
    };
  };
  orderLabels: Label[];
};

export interface ScannedLabelsState {
  scannedOrders: ScannedOrder[];
  setScannedOrders: (scannedOrders: ScannedOrder[]) => void;

  scannedLabelIds: string[];
  setScannedLabelIds: (scannedLabelIds: string[]) => void;
}

export const useScannedLabelsStore = create<ScannedLabelsState>()(
  persist(
    devtools(set => ({
      scannedOrders: [],
      setScannedOrders: scannedOrders => set({ scannedOrders }),

      scannedLabelIds: [],
      setScannedLabelIds: scannedLabelIds => set({ scannedLabelIds }),
    })),
    { name: 'use-scanned-labels-store', storage: createJSONStorage(() => localStorage) }
  )
);
